export default __webpack_public_path__ + "static/viinitie-banner-corporate-desktop-wide.6e0cbd665effe9e8d4350ced8a3b5f65.webp";